import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { fetchRequest, clearRequest } from 'actions/request';
import { startPreloader, finishPreloader } from 'actions/preloader';
import PaymentForm from 'containers/request/Payments/PaymentFormAccountant';
import RequestDetails from 'containers/request/Payments/RequestDetails';

class AddPayment extends Component {
  componentDidMount() {
    const { startPreloader, finishPreloader, fetchRequest, match } = this.props;
    startPreloader();
    fetchRequest(match.params.id).then(finishPreloader);
  }

  componentWillUnmount() {
    this.props.clearRequest();
  }

  render() {
    if (!this.props.request) return null;
    return (
      <div>
        <div>
          <Link to="/payments">
            <Button>&larr; Return to Unpaid Requests</Button>
          </Link>
        </div>
        <Col xs={12} md={5}>
          <h1 className="block-bottom-offset">Add Payment</h1>
          <PaymentForm history={this.props.history} />
        </Col>
        <Col xs={12} md={1} />
        <Col xs={12} md={6}>
          <h1 className="block-bottom-offset">Request Details</h1>
          <RequestDetails />
        </Col>
      </div>
    );
  }
}

function mapStateToProps({ request }) {
  return { request };
}

export default connect(
  mapStateToProps,
  {
    fetchRequest,
    startPreloader,
    finishPreloader,
    clearRequest
  }
)(AddPayment);



// WEBPACK FOOTER //
// ./src/containers/request/Payments/AddPayment.js